import { apiFunilObra } from "./utils/api";

export const getFunilObras = async () => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiFunilObra.get(`/api/FunilObra`).then((response) => response.data);
  return res;
}

export const getObrasAtivas = async (formatada = false) => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiFunilObra.get(`/api/Obras`, { params: { formatada: formatada } }).then((response) => response.data);
  return res;
}

export const salvarFunilObras = async (funisObras) => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiFunilObra.post('/api/FunilObra', funisObras).then((response) => {
    if (response.data === undefined) return response;
    return response.data;
  });
  return res;
};

export const marcarClienteEscritorio = async (clienteId) => {
  if (!Number.isSafeInteger(Number(clienteId)) || Number(clienteId) <= 0) {
    throw new Error("Cliente inválido para endereço de escritório.");
  }
  const response = await apiFunilObra.post(`/api/Cliente/Escritorio/${Number(clienteId)}`);
  if (response?.isSuccess === false) {
    throw new Error(response.message);
  }
  return response;
};